import { render } from "./index-detail.vue?vue&type=template&id=9f85da22&scoped=true"
import script from "./index-detail.vue?vue&type=script&lang=js"
export * from "./index-detail.vue?vue&type=script&lang=js"

import "./index-detail.vue?vue&type=style&index=0&id=9f85da22&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f85da22"]])

export default __exports__